/**
 * This is the registration routes configuration.
 * Only configure routes in this file.
 * @memberOf registration Module
 * @namespace registration Routes
 */
import registrationTemplate from './registration.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf registration Module.registration Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the registration state and assign the template and controller. */
    $stateProvider
		.state('login.registration', {
			url: '^/selfservice/registeruser',
			template: registrationTemplate,
			controller: 'registrationController',
			controllerAs: 'registrationController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/login/registration/registration.route.js